// extracted by mini-css-extract-plugin
module.exports = {"transparent":"styles_transparent__1K4zU"};